import React from 'react';
import { t } from 'ttag';
import { ChevronDown, Divider, IconButton, Select } from '@coolremote/shared';
import DeleteIcon from '@icons/DeleteIcon';
import { useStyles } from './styles';

/**
 * The "pick a register to add to this schedule" row, shown below the Actions
 * list after clicking "Add Controls".
 */
const AddActionSelector = ({ options, onSelect, onClose }) => {
  const classes = useStyles();

  return (
    <div className={classes.bodyRow}>
      <Select
        options={options}
        onChange={onSelect}
        placeholder={t`Select Control`}
        fullWidth
        searchable
        menuPortal
        className={classes.selectWrapper}
        classes={{
          menu: classes.menu,
          option: classes.option,
        }}
        arrowIcon={<ChevronDown className={classes.arrowIcon} />}
      />
      <Divider orientation="vertical" className={classes.divider} />
      <IconButton onClick={onClose}>
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

export default AddActionSelector;
